import React, { useRef, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import NumberFormat from 'react-number-format';
import { Form } from "react-bootstrap";
import MultiselectExtension from "../../../components/MultiselectExtension";

function EditTeamMemberDialog({ team, onClose, onCancel, editTeamMember, roles, otherRoles, }) {
 
  const PHONE_REGEX = /[^0-9 \-]/g;
  const [tempUser, setTempUser] = useState(team);
  const [userRole, setUserRole] = useState(team.userRole);
  const [selectedOtherRole, setSelectedOtherRole] = useState(team.userRoles.map(t=>{return t.roleId}).includes(24)); // 24 - other roleId
  const [otherRoleId, setOtherRoleId] = useState(tempUser.otherRoleId);
  const [phoneNumberChanged, setPhoneNumberChanged] = useState(false);
  const [editRoles, setEditRoles] = useState([]);
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [otherRoleChanged, setOtherRoleChanged] = useState(false);

  const restrictRoles = team.userRoles.filter(role =>
    (role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y")
  );
  const unRestrictRoles = team.userRoles.filter(role =>
    (!(role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y"))
  );
  // console.log('roles', userRole);

  function onPhoneTextChange(e) {
    const value = e.target.value.replace(PHONE_REGEX, '');
    setTempUser(prevState => {
      const nextState = { ...prevState };
      nextState.phoneNumber = value ? value : '';
      return nextState;
    });
    setPhoneNumberChanged(true);
    setSaveBtnDisable(false);
  }

  function onCellPhoneTextChange(e) {
    const value = e.target.value.replace(PHONE_REGEX, '');
    setTempUser(prevState => {
      const nextState = { ...prevState };
      nextState.cellNumber = value ? value : '';
      return nextState;
    });
    setPhoneNumberChanged(true);
    setSaveBtnDisable(false);
  }

  const handleOtherChange = e => {
    //console.log('team', team);
    const selection = e.currentTarget.value;
    setOtherRoleId(selection);

    setSaveBtnDisable(false);
    setOtherRoleChanged(true);
  }

  function handleRoleChange(optionsList, selectedItem)
  {
    
    let roleNames = restrictRoles.map(item => {
      return item.roleName;
    }).join(', ');
    let roleNames1 = optionsList.map(item => {
      return item.roleName;
    }).join(', ');
    setUserRole(roleNames && roleNames1 ? roleNames + ', ' + roleNames1 :
        (roleNames ? roleNames : (roleNames1 ? roleNames1 : 'Please select a role')));
    let updateRoleIds = optionsList.map(item => {
      return item.roleId;
    });
    //console.log('updateRoleIds',updateRoleIds);
    let existingRoleIds = unRestrictRoles.map(item => {
      return item.roleId;
    });
    //console.log('existingRoleIds',existingRoleIds);
    let newList = [];
    for(let i=0; i<unRestrictRoles.length;++i) {
      if(!updateRoleIds.includes(unRestrictRoles[i].roleId))
      newList.push({'roleId':unRestrictRoles[i].roleId,
        'roleName':unRestrictRoles[i].roleName,
        'orderId':unRestrictRoles[i].orderId,
        'action':'D'});
    }
    //console.log('newList deletes',newList);

    for(let i=0; i<optionsList.length;++i) {
      if(!existingRoleIds.includes(optionsList[i].roleId))
        newList.push({'roleId':optionsList[i].roleId,
        'roleName':optionsList[i].roleName,
        'orderId':optionsList[i].orderId,
        'action':'A'});
    }
    //console.log('newList',newList);
    if((restrictRoles.length + optionsList.length) > 0)
      setEditRoles(newList);
    else
      setEditRoles([]);

    if(optionsList.map(role=>{return role.roleId}).includes(24))
    {
      setSelectedOtherRole(true);
      setOtherRoleId(otherRoleId ? otherRoleId : 1); // default to vendor
    }
    else
    {
      setSelectedOtherRole(false);
      setOtherRoleId(null);
    }
    //console.log('length',restrictRoles.length + optionsList.length);
    setSaveBtnDisable(((((restrictRoles.length + optionsList.length) > 0) && newList.length> 0) || otherRoleChanged || phoneNumberChanged ) ? false : true);
  }

  // for Team member role reset ref and function
  const teamMemberRef  =  useRef()
  const resetTeamMemberRole = () => {
    teamMemberRef.current.resetSelectedValues();
    handleRoleChange([])
    
    
   
}; 

    return (
    <div className='react-confirm-alert-body'>
      <h4>Team Member Edit</h4>
      <br />
      <div className='edit-dialog--task'>
        <Row style={{ textAlign: 'left' }}>
            <Col xs={12} md={6} lg={5}>NAME:</Col>
            <Col xs={12} md={6} lg={5}>{tempUser.firstName + ' ' + tempUser.lastName}</Col>
            {/* <Col xs={12} md={6} lg={5}>{displayName}</Col> */}

        </Row>
        <br />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>COMPANY:</Col>
          <Col xs={12} md={6} lg={5}>{tempUser.company}</Col> 
        </Row>
        <br />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>EMAIL:</Col>
          <Col xs={12} md={6} lg={5}>{tempUser.email}</Col> 
        </Row>
        <br />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>ROLE:</Col>
          <Col xs={12} md={6} lg={5}><b>{userRole}</b></Col>
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}></Col>
          <Col xs={12} md={6} lg={7}>
            <MultiselectExtension options={roles.filter(t=>!team.userRoles.map(role=>{
              if(role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y") return role.roleId
            }).includes(t.roleId))}
                                  selectedValues={roles.filter(t=>team.userRoles.map(role=>{
                                    if(!(role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y")) return role.roleId
                                  }).includes(t.roleId))}
                                  onSelect={handleRoleChange}
                                  onRemove={handleRoleChange} 
                                  showCheckbox={true}
                                  displayValue="roleName"
                placeholder="Select or Remove Roles"
                ref={teamMemberRef}
                        resetSelectField={resetTeamMemberRole}
            /></Col>
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}></Col>
          <Col xs={12} md={6} lg={5}>
            {/* <MultiselectExtension options={roles.filter(t=>!team.userRoles.map(role=>{
              if(role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y") return role.roleId
            }).includes(t.roleId))}
                                  selectedValues={roles.filter(t=>team.userRoles.map(role=>{
                                    if(!(role.isOnlyApproverRole === "Y" || role.hasApprovals === "Y")) return role.roleId
                                  }).includes(t.roleId))}
                                  onSelect={handleRoleChange}
                                  onRemove={handleRoleChange} 
                                  showCheckbox={true}
                                  displayValue="roleName"
                placeholder="Select or Remove RoleView"
                ref={teamMemberRef}
                        resetSelectField={resetTeamMemberRole}
            /> */}
          </Col>
        </Row>
        <br/>
        {selectedOtherRole ?
        <div>
        <Row id='other-role-row' style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>OTHER ROLE:</Col>
          <Col xs={12} md={6} lg={7}>
            <Form.Control style={{width:'100%'}} as='select' id='user-otherrole-selector'  value={otherRoleId}  onChange={handleOtherChange}>
              <option
                  id='otherrole'
                  key='default'
                  value={0}
              >
                Select Other Role
              </option>
              {otherRoles.map((role, index) => (
                  <option
                      id='otherrole'
                      key={role.otherRoleId}
                      value={role.otherRoleId}
                  >{role.otherRoleName}
                  </option>
              ))}
            </Form.Control>
          </Col>
        </Row></div> : <div/> }
        <br />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>PHONE:</Col>
          <Col xs={12} md={6} lg={5}>
            <NumberFormat
              className='text-control'
              id='phoneNumber'
              autoComplete='off'
              type='text'
              value={tempUser.phoneNumber}
              onChange={onPhoneTextChange}
              placeholder='xxx-xxx-xxxx'
              format='###-###-####'
              mask=''
              style={{ paddingLeft: '5px', position: 'relative' }}
              disabled={false}
            />
          </Col>
        </Row>
        <br />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={12} md={6} lg={5}>CELL PHONE:</Col>
          <Col xs={12} md={6} lg={5}>
            <NumberFormat
              className='text-control'
              id='cellPhone'
              autoComplete='off'
              type='text'
              value={tempUser.cellNumber}
              onChange={onCellPhoneTextChange}
              placeholder='xxx-xxx-xxxx'
              format='###-###-####'
              mask=''
              style={{ paddingLeft: '5px', position: 'relative' }}
              disabled={false}
            />
          </Col>
        </Row>
       </div>
      <br />
      <Row style={{ textAlign: 'left' }}>
        <Col xs={6} md={3} lg={3}>
          <button disabled={saveBtnDisable}
            className='btn btn-primary start-5'
            onClick={() => {
              if(otherRoleChanged == true || phoneNumberChanged===true || editRoles.length > 0)
              {
                if(otherRoleChanged == true && editRoles.filter(t=>t.roleId===24).length === 0)
                {
                  editRoles.push({'roleId':24,
                    'roleName':'Other',
                    'action':'A'});
                }
                editTeamMember(tempUser, editRoles, phoneNumberChanged, otherRoleId);
                onClose();
              }
              else
              {
                setUserRole("Please select a role");
              }
            }}
          >
            Save
          </button>
        </Col>
        <Col xs={8} md={4} lg={3}>
          <button className='btn btn-primary start-5' onClick={() => {
            onCancel();
            onClose();
          }}>
            Cancel
          </button>
        </Col>
      </Row>
    </div>
  );
}

export default EditTeamMemberDialog;
